import sidebar from './sidebar';
import ui from './ui';
import router from './router';

export default {
  router,
  sidebar,
  ui,
};
